import AdvancedSearchBar from './AdvancedSearchBar'
import Metrics from './Metrics'
import Icon from '@mdi/react'
import { Switch, DatePicker, Layout } from 'antd'
import { PagesEnum, GraphQlEnum } from '../../utils/Enums'
import { mdiDatabaseSearchOutline, mdiFilter, mdiFilterRemove } from '@mdi/js'

const { RangePicker } = DatePicker
const { Header } = Layout

const SearchHeader = (props) => {
	const {
		segment,
		keyword,
		tabStatus,
		setKeyword,
		collection,
		orderLimits,
		collectionData,
		filterProperty,
		setOrderLimits,
		advancedSearch,
		setIsDateFiltered,
		setFilterProperty,
		setShowLateBiltyOrders,
		showMissingKanta,
		setShowMissingKanta,
		showActiveTrackers,
		showConnectedTrackers,
		setShowActiveTrackers,
		setShowConnectedTrackers,
	} = props

	return (
		<Header className='!bg-secondaryBackground !pl-0 !pb-4 !h-16 w-full'>
			<div className='flex flex-row justify-start items-center'>
				<AdvancedSearchBar
					segment={segment}
					tabStatus={tabStatus}
					collection={collection}
					keyword={keyword}
					setKeyword={setKeyword}
					filterProperty={filterProperty}
					setFilterProperty={setFilterProperty}
					placeholder='Search'
				/>
				{!keyword && PagesEnum[collection].showTimeFilter && collection === 'biltyTracking' && (
					<div className='flex flex-row items-center ml-3'>
						<RangePicker className='h-10 !rounded border !border-grey-50' value={orderLimits} onChange={(event) => setOrderLimits(event)} />
						<button
							onClick={() => {
								setIsDateFiltered(false)
								setOrderLimits(null)
							}}
							className='flex flex-row border bg-white px-4 rounded-md items-center text-sm h-[40px] ml-3'
						>
							<Icon className='text-red-400' path={mdiFilterRemove} size={1} />
							<span className='pl-1 w-full text-center font-[600] text-red-400 text-xs'>Clear</span>
						</button>
						<button
							onClick={() => {
								setIsDateFiltered(true)
								const variables = GraphQlEnum[segment]?.fetch?.['normal']?.getVariables({ segment, filterKey: 'dateRange', filterValue: orderLimits })
								advancedSearch?.queryFunction({
									variables: variables,
								})
							}}
							className='flex flex-row border bg-primary-800 px-4 rounded-md items-center text-sm h-[40px] ml-3'
						>
							<Icon className='text-white' path={mdiFilter} size={1} />
							<span className='pl-1 w-full text-center font-[500] text-white text-xs'>Filter</span>
						</button>
					</div>
				)}

				{keyword && filterProperty !== 'businessName' && PagesEnum[collection].showAdvancedSearch && tabStatus !== 'cancelled' && (
					<button
						className='flex flex-row border bg-white text-secondary-400 px-4 rounded-md items-center text-sm h-[40px] ml-3'
						onClick={() => {
							const variables = GraphQlEnum[segment]?.fetch?.['normal']?.getVariables({ segment, filterKey: filterProperty, filterValue: keyword })
							advancedSearch?.queryFunction({
								variables: variables,
							})
						}}
					>
						<Icon className='text-primary-800' path={mdiDatabaseSearchOutline} size={1} />
						<span className='pl-1 w-full text-center font-[600] text-primary-800 text-xs'>Advanced Search</span>
					</button>
				)}
				{tabStatus === 'inProgress' && (
					<div className='flex flex-row items-center justify-between h-[40px]'>
						<div className='border-l border-grey-75 h-[30px] mx-4 py-1' />
						<div className='flex flex-row border bg-white px-4 rounded-md items-center text-sm h-[40px] ml-3'>
							<p className='font-medium pr-4 text-black-300'>Show Missing Kanta</p>
							<Switch onChange={(checked) => setShowMissingKanta(checked)} className={showMissingKanta ? 'bg-green-400' : 'bg-white'} />
						</div>
					</div>
				)}
				{collection === 'biltyTracking' && <Metrics segment={segment} orderLimits={orderLimits} orders={collectionData} />}
				{collection === 'biltyTracking' && segment === 'Import' && (
					<div className='flex flex-row border bg-white text-secondary-400 px-4 rounded-md items-center text-sm h-[40px] ml-3'>
						<p className='font-semibold text-xs text-black-300 pr-2'>Late Bilty Orders</p>
						<Switch onChange={(checked) => setShowLateBiltyOrders(checked)} />
					</div>
				)}
				{collection === 'trackerManagement' && (
					<div className='flex flex-row h-full items-center'>
						<div className='border-l border-black-75 h-[30px] mx-4 py-1' />
						<div className='flex flex-row border bg-white px-4 rounded-md items-center text-sm h-[40px] ml-3'>
							<p className='font-[500] pr-4 text-black-300'>Show Active Only</p>
							<Switch onChange={(checked) => setShowActiveTrackers(checked)} className={showActiveTrackers ? 'bg-green-400' : 'bg-white'} />
						</div>
						<div className='flex flex-row border bg-white px-4 rounded-md items-center text-sm h-[40px] ml-3'>
							<p className='font-[500] pr-4 text-black-300'>Show Connected Only</p>
							<Switch onChange={(checked) => setShowConnectedTrackers(checked)} className={showConnectedTrackers ? 'bg-green-400' : 'bg-white'} />
						</div>
					</div>
				)}
			</div>
		</Header>
	)
}

export default SearchHeader
